// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_colour_code: yup.string().label("Colour code").required(),
  mr_product_colour_name: yup.string().label("Colour name").required()
})